/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAttachment = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M8.883 11.007A1 1 0 0 0 9 13h8l.176-.005A3 3 0 0 0 17 7H9l-.217.005A5 5 0 0 0 9 17h10v2H9A7 7 0 1 1 9 5h8a5 5 0 0 1 0 10H9l-.176-.005A3 3 0 0 1 9 9h6v2H9z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgAttachment as Attachment };
